import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';

const state = () => ({
  private_networks: [],
});

const mutations = {
  setPrivateNetworks(state: any, networks: any) {
    state.private_networks = JSON.parse(JSON.stringify(networks));
  },
};

const actions = {
  updatePrivateNetwork({ commit, state }: any, network: any = null) {
    if (network && network.id) {
      const index = state.private_networks.findIndex((item: any) => item.id === network.id);
      if (index !== -1) {
        state.private_networks[index] = {
          ...state.private_networks[index],
          ...network,
        };
      }
      commit('setPrivateNetworks', state.private_networks);
    }
  },
  addPrivateNetwork({ commit, state }: any, network: any = null) {
    if (network && network.id) {
      const networks = state.private_networks.filter((item: any) => item.id !== network.id);
      networks.push(network);
      commit('setPrivateNetworks', networks);
    }
  },
  removePrivateNetwork({ commit, state }: any, network: any = null) {
    if (network && network.id) {
      const networks = state.private_networks.filter((item: any) => item.id !== network.id);
      commit('setPrivateNetworks', networks);
    }
  },
  getPrivateNetworks({ commit, rootState }: any, networks: any = null) {
    return new Promise(resolve => {
      if (networks) {
        commit('setPrivateNetworks', networks);
        resolve(networks);
      } else {
        privateNetworkService
          .getPrivateNetworks(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId)
          .then((data: any) => {
            commit('setPrivateNetworks', data.private_networks);
            resolve(data);
          });
      }
    });
  },
};

const getters = {
  getPrivateNetwork: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.private_networks.find((item: any) => id === item.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
